import Dialog from '../../ui/modal/Dialog';
import React, {useMemo, useState} from 'react';
import {handleError, handleSuccess} from '../../utils/Apollo';
import {useMutation, useQuery} from '@apollo/client';
import gql from 'graphql-tag';
import {DateTime} from 'luxon';
import {EventsFeed, QueryEventsArgs} from '../../schema';
import UIInput from "../../ui/form/UIInput";
import UIWysiwig, {WysiwigButtons} from "../../ui/form/UIWysiwig";
import * as Yup from "yup";
import {Form as FormikForm, Formik, FormikHelpers, FormikValues} from 'formik';
import {ModalWidth} from "../../ui/modal/Modal";

type Props = {
  id: string
  eventId: string
  show: boolean
  setShowDialog: (close: boolean) => void
}

interface QueryFeed {
  events: EventsFeed
}

export default function SendEmailDlg({id, eventId, show, setShowDialog}: Props) {
  const [transferAttendee] = useMutation(transferMutation);
  const [newEventId, setNewEventId] = useState<string | undefined>(undefined);
  const [showError, setShowError] = useState(false);

  const startBeginsOn = useMemo(() => DateTime.utc().plus({minutes: 1}).toString(), []);

  const {data, loading, error} = useQuery<QueryFeed, Pick<QueryEventsArgs, "startBeginsOn">>(query, {
    variables: {
      startBeginsOn
    }
  });

  const onConfirmTransfer = () => {
    if (!newEventId) {
      setShowError(true);
      return;
    }
    transferAttendee({
      variables: {id, eventId: newEventId}
    }).then(() => {
      handleSuccess(`Attendee has been transferred`);
      setShowDialog(false);
    }, (apolloError) => handleError(apolloError));
  }

  const onSend = (values: FormikValues, helpersReact: FormikHelpers<FormikValues>) => {
    // const data: EmailNotificationTemplateInput = {
    //   subject: values.subject,
    //   body: values.body,
    // };
    // const submit = template?.id ? submitOnUpdate({
    //   variables: {
    //     id: template.id,
    //     licenseTypeId,
    //     data
    //   }
    // }) : submitOnCreate({variables: {licenseTypeId, data}});
    // helpersReact.setSubmitting(true);
    // submit.then(
    //   () => {
    //     handleSuccess('License renewal notification was saved');
    //   },
    //   (apolloError) => handleError(apolloError)
    // ).finally(() => helpersReact.setSubmitting(false));
  };


  const initialValues = {
    subject: '',
    body: '',
  };
  const validation = Yup.object({
    subject: Yup.string().required('Required'),
    body: Yup.string().required('Required'),
  });


  return (
    <Dialog show={show} actionBtnTitle="Send email" onClose={() => setShowDialog(false)} width={ModalWidth.WIDE}
            title={`Compose Email`} onConfirm={() => onConfirmTransfer()} closeBtnTitle="Cancel">
      <>
        {loading && <div>Loading...</div>}
        {error && <div>{error.message}</div>}
        {data &&
          <>
            <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onSend}>
              {({isSubmitting}) =>
                <FormikForm>
                  <UIInput name="subject" id="subject" label="Subject" className="mb-4"/>
                  <UIWysiwig name="body" id="body" minHeight={250} buttons={WysiwigButtons.default()}
                    tags={[["Event start date", "{{event.start_date}}"]]}/>
                </FormikForm>
              }
            </Formik>
          </>
        }
      </>
    </Dialog>
  )
}

const query = gql`
  query SelectEvents($startBeginsOn: DateTime!) {
    events: events(startBeginsOn: $startBeginsOn, orderBy: start_asc, count: -1) {
      events {
        id
        title
        schedule {
          start
        }
      }
    }
  }
`

const transferMutation = gql`
  mutation TransferMutation($id: ID!, $eventId: ID!, $sendWelcomeEmail: Boolean!) {
    transferAttendee(attendeeId: $id, eventId: $eventId, sendWelcomeEmail: $sendWelcomeEmail) {
      id
      permissions
      status
    }
  }
`;
